import { makeApiTypes } from 'sidecar-utility-library'
import reduceReducers from 'reduce-reducers'

import { default as applicantReducer } from './applicant'
import { default as estimateReducer } from './estimate'
import { default as localReducer } from './local'
import { default as medicalHistoryReducer } from './medicalHistory'
import { default as packageReducer } from './package'
import { default as registrationReducer } from './registration'

export * from './applicant'
export * from './estimate'
export * from './local'
export * from './medicalHistory'
export * from './package'
export * from './registration'

export const types = {
  // applicants
  ...makeApiTypes('FETCH_APPLICANTS', 'applicant'),
  ...makeApiTypes('SAVE_APPLICANTS', 'applicant'),
  ...makeApiTypes('SAVE_UNCOVERED_APPLICANT', 'applicant'),
  ...makeApiTypes('DELETE_APPLICANT', 'applicant'),
  ...makeApiTypes('FETCH_SAVED_QUOTE', 'applicant'),
  ...makeApiTypes('FETCH_SSN', 'applicant'),
  // local
  SET_APPLICANTS: 'applicant/SET_APPLICANTS',
  ADD_APPLICANT: 'applicant/ADD_APPLICANT',
  UPDATE_APPLICANT: 'applicant/UPDATE_APPLICANT',
  REMOVE_APPLICANT: 'applicant/REMOVE_APPLICANT',
  CLEAR_APPLICANTS: 'applicant/CLEAR_APPLICANTS',
  // medicalHistory
  ...makeApiTypes('FETCH_MEDICAL_HISTORY', 'applicant'),
  TOGGLE_MEDICAL_HISTORY: 'applicant/TOGGLE_MEDICAL_HISTORY',
  ...makeApiTypes('VALIDATE_MEDICAL_HISTORY', 'applicant'),
  // packages
  CLEAR_PACKAGES: 'applicant/CLEAR_PACKAGES',
  ...makeApiTypes('FETCH_PACKAGES', 'applicant'),
  ...makeApiTypes('FETCH_FUTURE_PACKAGES', 'applicant'),
  SELECT_PACKAGE: 'applicant/SELECT_PACKAGE',
  // estimate
  ...makeApiTypes('CUSTOMIZE_PACKAGE', 'applicant'),
  ...makeApiTypes('FETCH_ESTIMATE', 'applicant'),
  ...makeApiTypes('FETCH_BENEFIT_ESTIMATE', 'applicant'),
  RESET_BENEFIT_ESTIMATE: 'applicant/RESET_BENEFIT_ESTIMATE',
  CLEAR_BENEFIT_ESTIMATE: 'applicant/CLEAR_BENEFIT_ESTIMATE',
  ...makeApiTypes('FETCH_REINSTATE_ESTIMATE', 'applicant'),
  // registration
  ...makeApiTypes('CHECK_REGISTRATION_STATUS', 'applicant'),
  ...makeApiTypes('VALIDATE_ACCOUNT', 'applicant'),
  ...makeApiTypes('VERIFY_ACCOUNT', 'applicant'),
  ...makeApiTypes('REGISTER_ACCOUNT', 'applicant'),
  ...makeApiTypes('ADD_SSN', 'applicant'),
  CLEAR_REGISTRATION: 'registration/CLEAR_REGISTRATION',
}

export const initialState = {
  applicants: {
    busy: false,
    error: '',
    entities: {},
    primaryApplicant: {}, // primaryApplicant: { quote: { packageName: STRING } }
    dependents: [],
    fetchingQuote: false,
  },
  applicantDenied: '',
  futurePackages: {
    busy: null,
    error: '',
    entities: {},
  },
  packages: {
    busy: null, // TODO Why is this null and not false?
    error: '',
    /*
    type CustomizedPackage = {
      packageName: String
      prescriptionsCovered: Boolean,
      disabledBenefits: [],
      maxAnnualAllowance: number,
      deductible: number,
      insuranceFilingUuid: String ie 'sch_maternity_2020_2021',
    }
    **/
    entities: {}, // entities: { customizedPackage: CustomizedPackage[] }
    customQuote: [],
  },
  product: {
    busy: false,
    error: '',
    entities: [],
  },
  estimates: {
    busy: {},
    error: '',
    entities: {},
  },
  disabledBenefits: {
    busy: false,
    error: '',
    entities: [],
  },
  test: {
    busy: false,
    error: '',
    entities: {},
  },
  validatedAccount: {
    busy: false,
    error: '',
  },
  verifyAccount: {
    busy: false,
    error: '',
  },
  checkRegistrationStatus: {
    busy: false,
    error: '',
  },
  addSSN: {
    busy: false,
    error: '',
  },
  registerAccount: {
    busy: false,
    error: '',
  },
}

export default reduceReducers(
  applicantReducer,
  estimateReducer,
  localReducer,
  medicalHistoryReducer,
  packageReducer,
  registrationReducer,
  // initial state must always be last
  initialState,
)
